import { render } from "./App.vue?vue&type=template&id=c08a3172"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c08a3172&lang=css"
script.render = render

export default script